var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAlarmReview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4758_1874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 8.08108C5 6.37945 6.41482 5 8.16008 5H17.3631C19.1084 5 20.5232 6.37945 20.5232 8.08108V12.1892H18.9432V8.08108C18.9432 7.23026 18.4991 6.54054 17.3631 6.54054H8.16008C7.28745 6.54054 6.58004 7.23026 6.58004 8.08108V19.3784C6.58004 20.2292 7.28745 20.9189 8.16008 20.9189H13.9397V22.4595H8.16008C6.41482 22.4595 5 21.08 5 19.3784V8.08108Z",
    fill: "url(#paint0_linear_4758_1874)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9501 8.33784C8.51379 8.33784 8.16008 8.6827 8.16008 9.10811C8.16008 9.53352 8.51379 9.87838 8.9501 9.87838H16.3098C16.7461 9.87838 17.0998 9.53352 17.0998 9.10811C17.0998 8.6827 16.7461 8.33784 16.3098 8.33784H8.9501Z",
    fill: "url(#paint1_linear_4758_1874)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9501 11.4189C8.51379 11.4189 8.16008 11.7638 8.16008 12.1892C8.16008 12.6146 8.51379 12.9595 8.9501 12.9595H14.203C14.6394 12.9595 14.9931 12.6146 14.9931 12.1892C14.9931 11.7638 14.6394 11.4189 14.203 11.4189H8.9501Z",
    fill: "url(#paint2_linear_4758_1874)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16008 15.2703C8.16008 14.8449 8.51379 14.5 8.9501 14.5H12.0963C12.5326 14.5 12.8863 14.8449 12.8863 15.2703C12.8863 15.6957 12.5326 16.0405 12.0963 16.0405H8.9501C8.51379 16.0405 8.16008 15.6957 8.16008 15.2703Z",
    fill: "url(#paint3_linear_4758_1874)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2599 13.7297C19.3157 13.7297 18.4066 14.0954 17.7335 14.7522C17.0597 15.4095 16.6772 16.3056 16.6772 17.2446V20.4444C16.6772 20.6801 16.5814 20.9107 16.4037 21.084C16.2095 21.2735 16.0407 21.3589 15.8005 21.3589C15.6455 21.3589 15.5198 21.4903 15.5198 21.6524C15.5198 21.8145 15.6455 21.9459 15.8005 21.9459H24.7192C24.8743 21.9459 25 21.8145 25 21.6524C25 21.4903 24.8743 21.3589 24.7192 21.3589C24.4791 21.3589 24.3102 21.2735 24.116 21.084C23.9384 20.9107 23.8425 20.6801 23.8425 20.4444V17.2446C23.8425 16.3056 23.46 15.4095 22.7862 14.7522C22.1131 14.0954 21.204 13.7297 20.2599 13.7297Z",
    fill: "url(#paint4_linear_4758_1874)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8378 23.526C18.8378 23.2642 19.0501 23.052 19.3119 23.052H21.2079C21.4697 23.052 21.6819 23.2642 21.6819 23.526C21.6819 23.7878 21.4697 24 21.2079 24H19.3119C19.0501 24 18.8378 23.7878 18.8378 23.526Z",
    fill: "url(#paint5_linear_4758_1874)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 8.08108C5.25 6.52345 6.54688 5.25 8.16008 5.25H17.3631C18.9763 5.25 20.2732 6.52345 20.2732 8.08108V11.9392H19.1932V8.08108C19.1932 7.61533 19.0717 7.16244 18.7643 6.82374C18.4528 6.4806 17.9834 6.29054 17.3631 6.29054H8.16008C7.15538 6.29054 6.33004 7.08626 6.33004 8.08108V19.3784C6.33004 20.3732 7.15538 21.1689 8.16008 21.1689H13.6897V22.2095H8.16008C6.54688 22.2095 5.25 20.936 5.25 19.3784V8.08108ZM8.41008 9.10811C8.41008 8.8267 8.64585 8.58784 8.9501 8.58784H16.3098C16.614 8.58784 16.8498 8.8267 16.8498 9.10811C16.8498 9.38952 16.614 9.62838 16.3098 9.62838H8.9501C8.64585 9.62838 8.41008 9.38952 8.41008 9.10811ZM8.41008 12.1892C8.41008 11.9078 8.64585 11.6689 8.9501 11.6689H14.203C14.5073 11.6689 14.7431 11.9078 14.7431 12.1892C14.7431 12.4706 14.5073 12.7095 14.203 12.7095H8.9501C8.64585 12.7095 8.41008 12.4706 8.41008 12.1892ZM8.41008 15.2703C8.41008 14.9889 8.64585 14.75 8.9501 14.75H12.0963C12.4006 14.75 12.6363 14.9889 12.6363 15.2703C12.6363 15.5517 12.4006 15.7905 12.0963 15.7905H8.9501C8.64585 15.7905 8.41008 15.5517 8.41008 15.2703ZM17.9081 14.9311C18.5339 14.3206 19.38 13.9797 20.2599 13.9797C21.1397 13.9797 21.9858 14.3206 22.6116 14.9311C23.2379 15.5421 23.5925 16.3739 23.5925 17.2446V20.4444C23.5925 20.7484 23.7162 21.0432 23.9414 21.2629C24.0503 21.3692 24.1639 21.458 24.2947 21.519C24.4282 21.5813 24.5672 21.6089 24.7192 21.6089C24.7241 21.6089 24.7303 21.6105 24.7371 21.6176C24.7441 21.625 24.75 21.6367 24.75 21.6524C24.75 21.6681 24.7441 21.6798 24.7371 21.6872C24.7303 21.6943 24.7241 21.6959 24.7192 21.6959H15.8005C15.7957 21.6959 15.7895 21.6943 15.7826 21.6872C15.7756 21.6798 15.7698 21.6681 15.7698 21.6524C15.7698 21.6368 15.7756 21.625 15.7826 21.6177C15.7895 21.6105 15.7957 21.6089 15.8005 21.6089C15.9526 21.6089 16.0916 21.5813 16.2251 21.519C16.3558 21.458 16.4694 21.3692 16.5783 21.2629C16.8035 21.0432 16.9272 20.7484 16.9272 20.4444V17.2446C16.9272 16.3739 17.2818 15.5421 17.9081 14.9311ZM19.0878 23.526C19.0878 23.4023 19.1881 23.302 19.3119 23.302H21.2079C21.3316 23.302 21.4319 23.4023 21.4319 23.526C21.4319 23.6497 21.3316 23.75 21.2079 23.75H19.3119C19.1881 23.75 19.0878 23.6497 19.0878 23.526Z",
    stroke: "url(#paint6_linear_4758_1874)",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4758_1874",
    x: 4,
    y: 5,
    width: 22,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4758_1874"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4758_1874",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4758_1874",
    x1: 15.0069,
    y1: 5,
    x2: 15.0069,
    y2: 24.5135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D0D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4758_1874",
    x1: 15.0069,
    y1: 5,
    x2: 15.0069,
    y2: 24.5135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D0D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4758_1874",
    x1: 15.0069,
    y1: 5,
    x2: 15.0069,
    y2: 24.5135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D0D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4758_1874",
    x1: 15.0069,
    y1: 5,
    x2: 15.0069,
    y2: 24.5135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D0D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4758_1874",
    x1: 15.0069,
    y1: 5,
    x2: 15.0069,
    y2: 24.5135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D0D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4758_1874",
    x1: 15.0069,
    y1: 5,
    x2: 15.0069,
    y2: 24.5135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D0D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4758_1874",
    x1: 15.0069,
    y1: 5,
    x2: 15.0069,
    y2: 24.5135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEDE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlarmReview);
export default __webpack_public_path__ + "static/media/ic-alarm-review.cff9758b1a93680b3e50eafb5b96cc85.svg";
export { ForwardRef as ReactComponent };